<div class="calendar-controls flex items-center justify-between mb-4">
  <div class="flex gap-2 items-center">
    <div class="flex gap-4 items-center">
      <button
        type="button"
        (click)="resetDateSelector()"
        class="py-[5px] px-[10px] border-[1px] border-solid border-[#A3A3A3] rounded-[8px] font-[600] text-[12px] text-[#5C5C5C]"
      >
        Mes actual
      </button>
    </div>
    <div class="flex gap-2 items-center">
      <div
        (click)="moveDate(-1)"
        class="bg-[#429DCF] text-white px-1 pb-[2px] h-[15px] rounded-[3px] font-[600] text-[12px] leading-[1.2] cursor-pointer select-none"
      >
        &lt;
      </div>
      <div
        (click)="moveDate(1)"
        class="bg-[#429DCF] text-white px-1 pb-[2px] h-[15px] rounded-[3px] font-[600] text-[12px] leading-[1.2] cursor-pointer select-none"
      >
        &gt;
      </div>
    </div>
    <ng-container>
      <p class="ml-[15px] font-[600] text-[#5C5C5C] text-[12px]">
        {{ selectedDate | date : "dd MMMM yyyy" }}
      </p>
    </ng-container>
  </div>
</div>

<!-- planning por horas -->
<div class="relative overflow-x-auto rounded-[8px] mb-10">
  <div class="scrollable-table">
    <table class="table-auto border-collapse w-full">
      <thead>
        <tr class="border-b border-gray-200">
          <th class="hour-column p-2">Hora</th>
          <th class="p-2 !text-center">
            Cangas de Onis -Avda. Covadonga nº 17 bajo
          </th>
          <th class="p-2 !text-center">
            Ribadesella (C. Marques de Argüelles s/n)
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let hour of filteredHourData; let i = index"
          class="border-t border-gray-200"
        >
          <td class="hour-container p-2 border-r border-gray-200">
            <div class="hour-wrapper">
              {{ hour.hour }}
            </div>
          </td>
          <td class="border border-gray-200 bg-white !text-center">
            {{
              getLocationData(
                "Cangas de Onis -Avda. Covadonga nº 17 bajo",
                hour
              )
            }}
          </td>
          <td class="border border-gray-200 bg-white !text-center">
            {{
              getLocationData(
                "Ribadesella (C. Marques de Argüelles s/n)",
                hour
              )
            }}
          </td>

          <ng-template #emptyCell>
            <td class="p-2 border-r border-gray-200"></td>
          </ng-template>
        </tr>
      </tbody>
    </table>
  </div>
</div>
